module.exports = __webpack_public_path__ + "img/cym.5814c5a9.svg";